
import Loading from '@/components/common/Loading'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import SchemaTags from "@/components/common/SchemaTags";
import React from 'react'



const Desktop = dynamic(() => import("@/components/outlet/PetStore"), {
  loading: () => <Loading />
})

const Mobile = dynamic(() => import("@/components/outlet/PetStoreMobile"), {
  loading: () => <Loading />
})


const petstore = ({mobileView}) => {
    return(
        <>
        <Head>
                <title> Pet Store Billing Software | POS System for Pet Stores</title>
                <link rel="canonical" href="https://queuebuster.co/outlet/pet-store-pos-billing-software" />
                <link rel="alternate" href="https://queuebuster.co/outlet/pet-store-pos-billing-software" hrefLang="en" />
                <meta name="description" content="Streamline your pet store operations with QueueBuster’s POS Billing Software. Easily manage inventory and billing of pet food, toys, and accessories—all in one pos." />
                <meta property="og:title" content="Make Every Paw-Chase Seamless with QueueBuster’s Pet Store POS" />
                <meta property="og:description" content="Manage your pet store like a pro! QueueBuster’s POS Billing Software simplifies billing, tracks inventory, and keeps your store running in purrfect order." />
                <meta property="og:image" content="" />
                <meta property="og:url" content="https://queuebuster.co/outlet/pet-store-pos-billing-software" />
            </Head>
         <SchemaTags page="pet-store-pos-billing-software" />
          {mobileView ?  <Mobile/>: <Desktop/>}
        </>
    )
}

export default petstore